import { ChartType } from 'src/lib/client/useMovieChart';
import styled from 'src/lib/styles/css';

//#region [Props]
type ChartTypeLabelProps = {
	chartType: ChartType;
};
//#endregion

//#region [Component]
export default function ChartTypeLabel({ chartType }: ChartTypeLabelProps) {
	let chartTypeText;

	if (chartType === "week") chartTypeText = "Uken";
	if (chartType === "weekend") chartTypeText = "Helgen";
	if (chartType === "year") chartTypeText = "År";
	if (chartType === "opening") chartTypeText = "Åpningshelg";

	return <span>{chartTypeText}</span>;
}
//#endregion
